import {Col, Row, Select} from "antd";
import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import TransferGroupingTable from "./TransferGroupingTable";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";

const TransferGrouping = () => {
    const history = useHistory();
    const stores = useStore();
    const [fromCenter, setFromCenter] = useState(null);
    const [toCenter, setToCenter] = useState(null);
    const [status, setStatus] = useState(null);
    const [page, setPage] = useState(1);
    const [transferGroupsLoading, transferGroups, _, __, refetch] = useFetch({
        fetchFn: () =>
            stores.transferStore.transferGroups({
                ...(fromCenter && {fromId: fromCenter}),
                ...(toCenter && {toId: toCenter}),
                ...(status !== undefined && {status: status}),
                page,
                limit: 10
            }),
        loading: true,
        showLoading: true,
        dependencies: [fromCenter, toCenter, status, page]
    });

    const [fromCentersLoading, fromCenters] = useFetch({
        fetchFn: () => stores.transferStore.transferCenters({type: "main", owner: "external"}),
        loading: true,
        dependencies: []
    });

    const [toCentersLoading, toCenters] = useFetch({
        fetchFn: () => stores.transferStore.transferCenters({type: "main", owner: "vigo"}),
        loading: true,
        dependencies: []
    });

    const handlePageChange = page => {
        setPage(page);
    };

    return (
        <div>
            <h1>Transfer Grupları</h1>
            <Row
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    marginBottom: "50px"
                }}
            >
                <div style={{display: "flex", gap: "20px", width: "50%"}}>
                    <Col span={6}>
                        <Select
                            title="From"
                            placeholder="From"
                            style={{width: "100%"}}
                            onChange={value => setFromCenter(value)}
                            allowClear
                        >
                            {fromCenters?.result?.map(center => (
                                <Select.Option value={center._id}>{center.name}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col span={6}>
                        <Select
                            title="To"
                            placeholder="To"
                            style={{width: "100%"}}
                            onChange={value => setToCenter(value)}
                            allowClear
                        >
                            {toCenters?.result?.map(center => (
                                <Select.Option value={center._id}>{center.name}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col span={6}>
                        <Select
                            title="Durum"
                            placeholder="Durum"
                            style={{width: "100%"}}
                            onChange={value => setStatus(value)}
                            allowClear
                        >
                            <Select.Option value={"created"}>Oluşturuldu</Select.Option>
                            <Select.Option value={"pending"}>Bekleniyor</Select.Option>
                            <Select.Option value={"completed"}>Tamamlandı</Select.Option>
                        </Select>
                    </Col>
                </div>
                <div>
                    <Col>
                        <CustomButton
                            onClick={() => history.push("/transfers/transfers?status=waiting")}
                        >
                            Planlanacak Sevkiyatlar
                        </CustomButton>
                    </Col>
                </div>
            </Row>
            <Row>
                <TransferGroupingTable
                    transferGroups={transferGroups}
                    refetch={refetch}
                    page={page}
                    setPage={setPage}
                />
            </Row>
        </div>
    );
};

export default TransferGrouping;
